<div class="p-2 pt-3">
  <app-location-info [autoRemove]="autoRemove" [infoProperty]="infoProperty" (addressEvent)="setAddress($event)"></app-location-info>

  <feature-info [featuresData]="featuresData" [layer]="layer"></feature-info>

  <!-- ── Action Buttons ─────────────────────────────────────────────── -->
  <div
    class="d-flex flex-column gap-2 pt-1"
    [class.hidden]="
      propertyLoadStatus === propertyStatus.downloading || damageLoadStatus === propertyStatus.downloading
    ">
    <div class="d-flex gap-1">
      <span
        class="flex-fill"
        [matTooltip]="enabledProperties
          ? 'This feature provides access to property records. Learn more: ' + viewerConfigurationService.getViewerConfiguration().propertyAttributesUrl
          : 'This feature provides access to property records. To enable this for your organization, learn more here: ' +
            viewerConfigurationService.getViewerConfiguration().propertyAttributesUrl"
        [matTooltipClass]="enabledProperties ? 'non-truncated-property-tooltip' : 'non-truncated-property-tooltip-disabled'">
        <button
          matButton="outlined"
          color="primary"
          class="w-100 px-1"
          [class.btn-loaded]="propertyLoadStatus === propertyStatus.finished"
          [disabled]="!enabledProperties || propertyLoadStatus === propertyStatus.error || propertyLoadStatus === propertyStatus.finished"
          (click)="getAdditionalProperties()">
          Property Info
        </button>
      </span>

      <span
        class="flex-fill"
        [matTooltip]="getDamageAssessmentTooltip()"
        [matTooltipClass]="enabledProperties ? 'non-truncated-damage-tooltip' : 'non-truncated-damage-tooltip-disabled'">
        <button
          matButton="outlined"
          color="primary"
          class="w-100 px-1"
          [class.btn-loaded]="damageLoadStatus === propertyStatus.finished"
          [disabled]="!isDamageEnabled || damageLoadStatus === propertyStatus.error || damageLoadStatus === propertyStatus.finished"
          (click)="getDamageAssessment()">
          Damage Info
        </button>
      </span>

      <span
        class="flex-fill"
        [matTooltip]="enabledPropertiesReport
          ? 'Request a full Property or Damage Report PDF: ' + viewerConfigurationService.getViewerConfiguration().propertyAttributesUrl
          : 'To enable Property Report PDFs for your organization, learn more here: ' +
            viewerConfigurationService.getViewerConfiguration().propertyAttributesUrl"
        [matTooltipClass]="enabledPropertiesReport ? 'non-truncated-pdf-tooltip' : 'non-truncated-pdf-tooltip-disabled'">
        <button
          matButton="outlined"
          color="primary"
          class="w-100 px-1"
          [disabled]="!enabledPropertiesReport || !viewerService.getReportReady()"
          (click)="openPropertyDialog()">
          Generate Report
        </button>
      </span>
    </div>
  </div>



  <!-- ── Loaders ────────────────────────────────────────────────────── -->
  <div *ngIf="propertyLoadStatus !== null && propertyLoadStatus !== propertyStatus.finished" class="property-loader py-3">
    <phoenix-property-loader
      [status]="propertyLoadStatus"
      [errorMessage]="'No property data was returned for this location'"
      [downloadingMessage]="'Gathering property information...'"></phoenix-property-loader>
  </div>
  <div
    *ngIf="damageLoadStatus !== null && damageLoadStatus !== propertyStatus.finished"
    class="property-loader py-3">
    <phoenix-property-loader
      [status]="damageLoadStatus"
      [errorMessage]="'No damage assessment information was returned.'"
      [downloadingMessage]="'Gathering damage assessment information...'"></phoenix-property-loader>
  </div>

  <!-- ── Display Components ─────────────────────────────────────────── -->
  @if(propertyLoadStatus === propertyStatus.finished){
          <lib-property-overview
                  [propertyData]="propertyData"
                  [measurementSystem]="measurementSystem"
                  [visibilityValues]="defaultVisibilityValues"
                  [discreteEnabled]="mapService.discreteEnabled$ | async"
                  (measurementSystemChange)="onMeasurementSystemChange($event)"
                  (visibilityChange)="onPropertyVisibilityChange($event)"
                  (zoomRequested)="onZoomRequested($event)">
          </lib-property-overview>
  }

  @if(damageLoadStatus === propertyStatus.finished){
      <div class="py-3">
          <lib-damage-overview
                  [damageData]="damageData"
                  [measurementSystem]="measurementSystem"
                  [visibilityValues]="defaultVisibilityValues"
                  [discreteEnabled]="mapService.discreteEnabled$ | async"
                  (measurementSystemChange)="onMeasurementSystemChange($event)"
                  (visibilityChange)="onDamageVisibilityChange($event)"
                  (zoomRequested)="onZoomRequested($event)">
          </lib-damage-overview>
      </div>
  }

</div>
